<template>
  <div class="logo-upload-step">
    <template v-if="!decorationBoxLoading">
      <template v-if="!hasLogo">
        <!-- Upload input -->
        <UploadLogoButton
          :graphicButtonHint="'Upload your team graphics'"
          :refName="refName"
          :hideInput="false"
          :hasCustomer="false"
          @uploadingLogo="emitUploadingDefaultLogo"
          @logoHasBeenUploaded="emitDefaultLogoHasBeenUploaded"
          @openManageLogosModal="emitOpenManageLogosModal"
        />

        <!-- Help text -->
        <p class="help-text">
          <strong>Vector graphics (such as AI or SVG) are preferred</strong>
          since they are of higher quality and ready for production.
        </p>
        <p class="help-text">
          If you do not have a vector, our graphic artists will vectorize it for
          you, but this could add extra time for production and might require
          final Art Approval before we can begin.
        </p>
      </template>

      <template v-else>
        <div class="uploaded-logo">
          <div class="uploaded-logo-transparent-bg">
            <div id="graphic-preview">
              <img class="graphic-preview-image" :src="logoSrc" />
            </div>
          </div>
          <button title="delete" class="btn delete-btn remove-logo">
            <img
              src="@/assets/icons/ui/trash-outline-red.svg"
              alt="delete"
              @click="removeLogo()"
            />
          </button>
        </div>
        <button
          v-if="uploadedLogos && uploadedLogos[0]"
          type="button"
          class="save-btn"
          @click="saveLogo()"
        >
          Save
        </button>
      </template>
    </template>
    <Loader v-else />
  </div>
</template>

<script>
import UploadLogoButton from "@/components/Utils/Logos/UploadLogoButton.vue";
import Loader from "@/components/Utils/Loader";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "LogoUploadBox",

  methods: {
    ...mapActions("project", [
      "updateCustomGraphic",
    ]),
    ...mapActions("showroom", [
      "setCustomizationBoxLoading",
      "getDecorationsForSelectedCatalogLayouts",
      "setCustomizationStep",
    ]),
    ...mapActions("uploadLogos", ["clearLogos", "closeEditLogoModal"]),

    emitUploadingDefaultLogo(payload) {
      console.clear();
      console.log("emitUploadingDefaultLogo", payload);
    },

    emitDefaultLogoHasBeenUploaded(payload) {
      console.clear();
      console.log("emitDefaultLogoHasBeenUploaded", payload);
    },

    emitOpenManageLogosModal(payload) {
      console.clear();
      console.log("emitOpenManageLogosModal", payload);
    },

    async removeLogo() {
      await this.closeEditLogoModal();
      this.getDecorationsForSelectedCatalogLayouts();
    },

    async saveLogo() {
      //todo set loading
      this.setCustomizationBoxLoading(true);
      //save logo to uniform or spiritwear

      await this.updateCustomGraphic({
        type: this.typeOfDecoration === "spiritwear" ? "spiritwear" : "uniform",
        graphic: this.uploadedLogos[0],
      });

      //regen decorations //todo regen only by type: this.typeOfDecoration === 'spiritwear' ? "spiritwear" : "uniform",
      this.getDecorationsForSelectedCatalogLayouts();

      //return to start custom box
      this.setCustomizationStep("home");

      this.setCustomizationBoxLoading(false);
    },
  },

  mounted() {
    this.clearLogos();
  },

  computed: {
    ...mapState("uploadLogos", ["uploadedLogos", "editableLogo"]),
    ...mapState("showroom", ["decorationBoxLoading"]),
    ...mapGetters("project", [
      "uniformCustomGraphic",
      "spiritwearCustomGraphic",
    ]),

    hasLogo() {
      return !!this.logoSrc;
    },

    /*logoSrc() {
      if (this.typeOfDecoration === "spiritwear") {
        if (this.spiritwearCustomGraphic)
          return this.spiritwearCustomGraphic.url;
      } else {
        if (this.uniformCustomGraphic) return this.uniformCustomGraphic.url;
      }
      return this.uploadedLogos?.length ? this.uploadedLogos[0]?.content : "";
    },*/
    logoSrc() {
      return this.editableLogo?.content;
    },

    defaultLogoToBeSelected() {
      return this.typeOfDecoration === "spiritwear" ? "spiritwear" : "uniforms";
    },

    refName() {
      return this.defaultLogoToBeSelected + "-default-upload-btn";
    },
  },

  props: {
    typeOfDecoration: {
      type: String, //team uniform / spiritwear
    },
  },

  components: {
    UploadLogoButton,
    Loader,
  },
};
</script>

<style lang="scss" scoped>
#app {
  .logo-upload-step {
    margin: 15px 15px 0;
  }
  .uploaded-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 185px;
    width: 400px;

    .uploaded-logo-transparent-bg {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      background: url("~@/assets/logo-background.png");

      #graphic-preview {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 25px;

        img.graphic-preview-image {
          height: 100%;
        }
      }
    }

    .remove-logo {
      position: absolute;
      right: 0;
    }
  }

  .save-btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 50px;
    background: #26262c;
    border-radius: 6px;
    margin: 10px auto;
    color: white;
  }
}
</style>
